import { EnvConfigReceiptLookup } from '../interfaces/env-interfaces';

/**
 * The configuration is used throughout the application to determine how to connect
 * to the backend services and to set up the application test environment.
 */
export const environment: EnvConfigReceiptLookup = {
    production: false,
    useLock: true,
    appConfig: {
        envRegion: 'eu-west-1',
        envType: 'test',
        apiBaseUrl: 'test.chargeye.io',
        appBaseHostname: 'receipts.test.chargeye.io',
    },
    waf: {
        /** CAPTCHA site key for AWS WAF, used for Javascript integration
         * Please note that this is not a secret, it's safe to expose in the frontend code
         * the key is only used for specific domain and the actual validation is done in AWS WAF
         */
        captchaSiteKey:
            'CzQK9OAAQCh2/dE6l8Lzao3SrOMj5DScugTQmLg931iSfm9XS79m44YUXtNuq7sUSGmIyqB/Sz42MA6DxX6av3D0DRVRNK2Zx+WAVtjsaIR+rfMCBnFSHmjVDpea9zEEzTI6DqTXffBmdTJUHvMDEslrm0udQK1ccQBjs8fvyGb1svwAgGHRLCLW7Jed4VNgGzk9WYbPJOU4nkhKBZqffEWMxlmz1tWoLPPNVWzonsGeyvey/cwbnrsULonEroUALkJYusTg/ptct8d1jVtD8FdqHO3zSeANqrwzrr9fau4eBRCUWSZ8REiGXOJcjyIeOOhO0NAZhHCRsyFx9WzPrsj602IaVVqwfHIeZog6YZdFYVo7q0NwCOx9lZd0k6J9Mg7k3QaMZmPFLU2Q0asbh9KKEcak3CIOcEVie+1h8YeZiKzQFomNsuqh4WuM2FW04NZMtsKZU8rcxjl0HviInOiZdwaxAMXW6DqDGm5BISJn1OnM3xn1fQ04r5ouk1+WUhtnP8J0O61Wm1aEO2aw9HS1hIRGxaPKzZaT8p/xLGFweo0ibsyDVks30G31RvnIKY3Y/6BRZZ9vPgPgBAI4UgLM2feSQwp0DlcuQbjHaAeRSRVMftL7BK9i6XPtfh9UrlI/IxJnY3IDXfEwBsWqPA+wZFSKrqlwoa0oCQE4lTM=_0_1',
        captchaScriptUrl: 'https://b34447028270.eu-west-1.captcha-sdk.awswaf.com/b34447028270/jsapi.js',
    },
};
